import { render } from "./DetalleLugar.vue?vue&type=template&id=2dbb8f56"
import script from "./DetalleLugar.vue?vue&type=script&lang=js"
export * from "./DetalleLugar.vue?vue&type=script&lang=js"

import "./DetalleLugar.vue?vue&type=style&index=0&id=2dbb8f56&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__